import React, { useContext } from 'react';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';

import CtaImage from './CtaImage';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function TripleCta({ cuisine, optionsText, image }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <section className='Section GrayBg'>
      <div className={cn(styles.Cta, styles.Cta__list)}>
        { image && <CtaImage image={image} isResponsive /> }
        <div className={styles.Cta_copy}>
          <div>
            <h3>We Match You with the Best {cuisine} {vehicle_type}s</h3>
            <ul>
              <li>Free, no-obligation quotes customized for your event.</li>
              <li>Access to top-rated {cuisine} food {vehicleType}s in your area.</li>
              <li>{optionsText}</li>
            </ul>
          </div>
          <div>
            <h3>A Team of Event-Obsessed Experts</h3>
            <ul>
              <li>We handle the details, so you don&#39;t have to.</li>
              <li>Experienced professionals ensure smooth coordination.</li>
              <li>Dedicated support to answer your questions and assist with logistics.</li>
            </ul>
          </div>
          <div>
            <h3>100% Peace of Mind</h3>
            <ul>
              <li>Reliable {cuisine} food {vehicleType}s with proven track records.</li>
              <li>Backup vendors available in case of last-minute changes.</li>
              <li>Secure, hassle-free booking process.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TripleCta;
